// Shared Framer Motion variant presets so sections stay choreographed
// consistently. Transform/opacity only, except maskReveal's one-shot clip-path.

export const EASE_OUT = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: EASE_OUT },
  },
};

export const maskReveal = {
  hidden: { clipPath: 'inset(0 0 100% 0)', y: 24 },
  show: {
    clipPath: 'inset(0 0 0% 0)',
    y: 0,
    transition: { duration: 0.7, ease: EASE_OUT },
  },
};

export const chipPop = {
  hidden: { opacity: 0, scale: 0.7 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { type: 'spring', stiffness: 300, damping: 20 },
  },
};

export const staggerContainer = (stagger = 0.06, delay = 0) => ({
  hidden: {},
  show: {
    transition: { staggerChildren: stagger, delayChildren: delay },
  },
});
